// extracted by mini-css-extract-plugin
export default {"container":"staff_container__aTHw4","form":"staff_form__yIF8o","buttons":"staff_buttons__2eouK","viewCard":"staff_viewCard__cycBB","description":"staff_description__KHowJ"};